import { useState, useEffect, FunctionComponent } from 'react'

const Delayed: FunctionComponent<DelayedProps> = ({ children, delay = 200 }: DelayedProps) => {
  const [isVisible, setIsVisble] = useState<boolean>(false)

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setIsVisble(true)
    }, delay)

    return window.clearTimeout(timer)
  }, [delay])

  return isVisible ? children : null
}

interface DelayedProps {
  children: React.ReactElement;
  delay: number
}

export default Delayed
